import sx from 'utils/createSx';

export default sx({
  card: {
    display: 'flex',
    alignItems: `center`,
    textAlign: 'center',
    justifyItems: 'center',
    minWidth: '7rem',
    maxWidth: '30rem',
  },
});
